import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentPrintCopy } from "src/models/POS/DocumentPrintCopy.models";

interface DocumentPrintCopyState {
  documentPrintCopies: IDocumentPrintCopy[];
  documentPrintCopyToEdit: IDocumentPrintCopy | null;
}

const initialState: DocumentPrintCopyState = {
  documentPrintCopies: [],
  documentPrintCopyToEdit: null,
};

const documentPrintCopySlice = createSlice({
  name: "DocumentPrintCopy",
  initialState,
  reducers: {
    setDocumentPrintCopyList: (state, action: PayloadAction<IDocumentPrintCopy[]>) => {
      state.documentPrintCopies = action.payload;
    },
    setDocumentPrintCopyToEdit: (state, action: PayloadAction<IDocumentPrintCopy | null>) => {
      state.documentPrintCopyToEdit = action.payload;
    },
    concatListDocumentPrintCopy: (
      state: DocumentPrintCopyState,
      action: PayloadAction<IDocumentPrintCopy[]>
    ) => {
      state.documentPrintCopies = [...state.documentPrintCopies.concat(action.payload)];
    },
    addDocumentPrintCopy: (state, action: PayloadAction<IDocumentPrintCopy>) => {
      state.documentPrintCopies.push(action.payload);
    },
    updateDocumentPrintCopy: (state, action: PayloadAction<IDocumentPrintCopy>) => {
      let itemIndex = state.documentPrintCopies.findIndex(
        item => item.printCopyId === action.payload.printCopyId
      );
      if (itemIndex !== -1) state.documentPrintCopies[itemIndex] = action.payload;
    },
    deleteDocumentPrintCopy: (state, action: PayloadAction<string>) => {
      const newArray = state.documentPrintCopies.filter(
        item => item.printCopyId !== action.payload
      );
      state.documentPrintCopies = newArray;
    },
  },
});

export const {
  setDocumentPrintCopyList,
  concatListDocumentPrintCopy,
  setDocumentPrintCopyToEdit,
  addDocumentPrintCopy,
  updateDocumentPrintCopy,
  deleteDocumentPrintCopy,
} = documentPrintCopySlice.actions;

export default documentPrintCopySlice.reducer;
